import * as api from './index';
const t = '/teams';

export default {
  get: api.get(t),
  getAll: api.get(`${t}/all`),
  create: api.post(t),
  update: api.put(`${t}/:id`),
  del: api.del(`${t}/:id`)
};